import { useState, useEffect } from 'react';
import { API_URL } from '../config';
import { useAuth } from '../context/AuthContext';

export interface AiWatchlistStrategy {
    id: number;
    name: string;
    strategy_type: string;
    risk_profile: string | null;
}

/** Watchlists IA actives (id + nom), pour les listes de choix. */
export function useAiWatchlistStrategies() {
    const { token } = useAuth();
    const [strategies, setStrategies] = useState<AiWatchlistStrategy[]>([]);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!token) return;
        let cancelled = false;
        fetch(`${API_URL}/api/v1/ai-watchlist/strategies`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(res => (res.ok ? res.json() : Promise.reject(res.status)))
            .then((data: AiWatchlistStrategy[]) => {
                if (!cancelled) setStrategies(Array.isArray(data) ? data : []);
            })
            .catch(() => {
                if (!cancelled) setError(true);
            });
        return () => {
            cancelled = true;
        };
    }, [token]);

    return { strategies, error };
}
